import {cva} from 'class-variance-authority'

export const badgeVariants = cva('', {
  variants: {
    color: {
      secondary: '',
      info: '',
      alert: '',
      warning: '',
      success: '',
      primary: '',
    },
    appearance: {
      standard: '',
      inverted: '',
    },
    shape: {
      square: 'py-px px-[3px] rounded-sm',
      pill: 'py-px px-1 rounded-full',
    },
  },
  compoundVariants: [
    {
      color: 'secondary',
      appearance: 'standard',
      className: 'text-white bg-secondary border-secondary',
    },
    {
      color: 'info',
      appearance: 'standard',
      className: 'text-white bg-bostonBlue border-bostonBlue',
    },
    {
      color: 'alert',
      appearance: 'standard',
      className: 'text-white bg-thunderbird border-thunderbird',
    },
    {
      color: 'warning',
      appearance: 'standard',
      className: 'text-white bg-casablanca border-casablanca',
    },
    {
      color: 'success',
      appearance: 'standard',
      className: 'text-white bg-mountainMeadow border-mountainMeadow',
    },
    {
      color: 'primary',
      appearance: 'standard',
      className: 'text-white bg-primary border-primary',
    },

    {
      color: 'secondary',
      appearance: 'inverted',
      className: 'text-secondary bg-white border-secondary',
    },
    {
      color: 'info',
      appearance: 'inverted',
      className: 'text-bostonBlue bg-white border-bostonBlue',
    },
    {
      color: 'alert',
      appearance: 'inverted',
      className: 'text-thunderbird bg-white border-thunderbird',
    },
    {
      color: 'warning',
      appearance: 'inverted',
      className: 'text-casablanca bg-white border-casablanca',
    },
    {
      color: 'success',
      appearance: 'inverted',
      className: 'text-mountainMeadow bg-white border-mountainMeadow',
    },
    {
      color: 'primary',
      appearance: 'inverted',
      className: 'text-primary bg-white border-primary',
    },
  ],
  defaultVariants: {
    color: 'primary',
    appearance: 'standard',
  },
})
